var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon-More"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Vector",
    cx: 2.75,
    cy: 8,
    r: 1.25,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Vector_2",
    cx: 8.25,
    cy: 8,
    r: 1.25,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Vector_3",
    cx: 13.25,
    cy: 8,
    rx: 1.25,
    ry: 1.25,
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMore);
export default __webpack_public_path__ + "static/media/more.cda753db0cbfc2bf3d74c6c0de0ebff2.svg";
export { ForwardRef as ReactComponent };